"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtAlignItems = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtAlignItems = function SvgBtAlignItems(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("rect", {
    x: 12.5,
    y: 17.5,
    width: 7,
    height: 3,
    rx: 0.5,
    transform: "rotate(-90 12.5 17.5)",
    stroke: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8 8v12M20 20V8",
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
};

exports.SvgBtAlignItems = SvgBtAlignItems;